const ChatProgress = ({ text }) => {
  return (
    <div className="cp-row">
      <style>{`
        .cp-row { display: flex; align-items: center; gap: var(--space-3); margin-bottom: var(--space-6); }
        .cp-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--accent); animation: cp-pulse 1.2s ease-in-out infinite; flex-shrink: 0; }
        @keyframes cp-pulse { 0%, 100% { opacity: 0.25; transform: scale(0.85); } 50% { opacity: 1; transform: scale(1); } }
        .cp-text { font-family: var(--font-mono); font-size: 13px; color: var(--text-tertiary); letter-spacing: 0.02em; }
      `}</style>
      <span className="cp-dot" aria-hidden="true" />
      {text && <span className="cp-text">{text}</span>}
    </div>
  );
};

export default ChatProgress;
